import * as React from 'react'
import styled from 'styled-typed'
import { InstructionsCard } from 'snippet/instructionsCard'
import supportIcon from './snippetContainer/support.svg'
import { ActionButtonExternalLink } from 'uiComponents/buttons'
import { useTranslation } from 'translations'

const Button = styled(ActionButtonExternalLink)`
    width: 16em;
    margin-top: 0.7em;
    margin-right: 2.5em;
    display: inline-flex;
`

export function NeedHelpCardCard() {
    const { t } = useTranslation()
    const closedSubHeader = t('snippet.needHelp.closedSubHeader')

    return (
        <InstructionsCard iconSrc={supportIcon} header={t('snippet.needHelp.header')} closedSubHeader={closedSubHeader}>
            <div style={{ marginTop: '1.7em' }}>
                <Button href="https://meetings.hubspot.com/maitane" target="_blank">
                    {t('snippet.needHelp.getInTouch')}
                </Button>
                <Button
                    kind="action"
                    secondary
                    href="https://support.convious.com/help/convious-onboarding"
                    target="_blank"
                >
                    {t('snippet.needHelp.supportArticles')}
                </Button>
            </div>
        </InstructionsCard>
    )
}
